export enum DeviceActionsTypes {
  "LIST_DEVICE" = "LIST_DEVICE",
  "LIST_DEVICE_BY_DAY" = "LIST_DEVICE_BY_DAY",
  "ARCHIVE_DEVICE" = "ARCHIVE_DEVICE",
  "GET_DEVICE" = "GET_DEVICE",
  "CREATE_DEVICE" = "CREATE_DEVICE",
  "UPDATE_DEVICE" = "UPDATE_DEVICE",
  "UPDATE_ADMIN_DEVICE" = "UPDATE_ADMIN_DEVICE",
  "UPDATE_MULTIPLE_DEVICE" = "UPDATE_MULTIPLE_DEVICE",
  "CREATE_MULTIPLE_DEVICE" = "CREATE_MULTIPLE_DEVICE"
}

export enum DeviceMutationsTypes {
  "SET_DEVICE" = "SET_DEVICE",
  "SET_DEVICE_BY_DAY" = "SET_DEVICE_BY_DAY",
  "UPDATE_DEVICE" = "UPDATE_DEVICE",
  "CREATE_DEVICE" = "CREATE_DEVICE",
  "GET_DEVICE" = "GET_DEVICE",
  "UPDATE_MULTIPLE_DEVICE" = "UPDATE_MULTIPLE_DEVICE",
  "SET_MULTIPLE_DEVICE" = "SET_MULTIPLE_DEVICE",
  "REMOVE_DEVICE" = "REMOVE_DEVICE"
}

export enum DeviceGettersTypes {
  "DEVICE_BY_ID" = "DEVICE_BY_ID",
  "DEVICE_ALL_ID" = "DEVICE_ALL_ID",
  "GET_DEVICE_BY_DAY" = "GET_DEVICE_BY_DAY"
}
